import { Component, NgZone, OnInit, ViewEncapsulation } from '@angular/core';
import { UserService } from 'src/app/service/user.service';
import { Router } from '@angular/router';
import { ROUTES } from 'src/app/route/routes';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { Ship } from 'src/app/model/ship';
import { Constants } from 'src/app/constants/Constants';
import {
  GenericConfirmationComponent
} from "../../../components/dialog/generic-confirmation/generic-confirmation.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-login-landing',
  templateUrl: './login-landing.component.html',
  styleUrls: ['./login-landing.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class LoginLandingComponent implements OnInit {
  isLoading: boolean = false;
  wrongInput: boolean = false;

  username: string;
  true_username: string | null;
  password: string;
  selectedShip: Ship | null ;
  availableShips: Ship[] = Constants.SHIPS;

  constructor(
    private router: Router,
    private userService: UserService,
    private ngZone: NgZone,
    private spinner: SpinnerService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {}

  login() {
    // this.isLoading = true;
    this.spinner.show();
    let body = {
      username: this.username,
      password: this.password,
      ship: this.selectedShip?.id
    };

    this.userService.login(body).subscribe({
      next: (res: any) => {
        this.userService.setLoginInfo(res.auth);
        this.router.navigate([ROUTES.HOME.path]);
      },
      error: (err) => {
        this.showError(err?.error?.auth?.error);
        this.wrongInput = true;
        this.username = '';
        this.password = '';
        this.selectedShip = null;
        // this.isLoading = false;
        this.spinner.hide();
      },
    });
  }

  private showError(message?: string) {
    if (!message) message = 'edit_booking.show_error';

    this.dialog.open(GenericConfirmationComponent, {
      data: {
        message: message,
      },
    });
  }

  onDateInput(event: Event): void {
    const e = event as InputEvent;
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, ''); // Remove non-numeric characters
    if (!e.inputType.startsWith('delete')) {
      if (value.length >= 2 && value.length < 4) {
        value = value.slice(0, 2) + '/' + value.slice(2);
      } else if (value.length >= 4) {
        value =
          value.slice(0, 2) + '/' + value.slice(2, 4) + '/' + value.slice(4, 8);
      }

      input.value = value; // Update input field
      this.password = value;
    }
  }
}
